@if (loader.isLoading()) {
  <div
    class="global-loader-overlay position-fixed d-flex align-items-center justify-content-center"
    aria-live="polite"
    aria-busy="true"
  >
    <mat-spinner diameter="64" strokeWidth="8"></mat-spinner>
  </div>
}
